import {SkeletonBlock,SkeletonImage,SkeletonPage,SkeletonTextLines} from './SkeletonPrimitives';

export default function HeroSkeleton() {
  return (
    <section className="home-hero home-hero-skeleton skeleton-page" aria-busy="true">
      <div className="hero-content page-width" aria-hidden="true">
        <SkeletonBlock className="skeleton-eyebrow" />
        <div className="skeleton-heading">
          <SkeletonBlock className="skeleton-heading-line skeleton-heading-line-wide" />
          <SkeletonBlock className="skeleton-heading-line skeleton-heading-line-medium" />
          <SkeletonBlock className="skeleton-heading-line skeleton-heading-line-short" />
        </div>
        <div className="hero-bottom">
          <SkeletonTextLines className="skeleton-description" />
          <div className="hero-actions">
            <SkeletonBlock className="skeleton-button skeleton-button-primary" />
            <SkeletonBlock className="skeleton-button skeleton-button-secondary" />
          </div>
        </div>
      </div>
      <SkeletonImage className="hero-skeleton-image" />
    </section>
  );
}